import { useState } from "react";
import styles from "./styles.module.css";
import CloseShiftDialog from "../../popups/CloseShiftDialog/CloseShiftDialog";
import { STORAGE_KEYS } from "const";
import { Select, MenuItem, FormControl } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const menuItems = [
  { key: "shiftReport", label: "Shift Report" },
  { key: "salesSummary", label: "Sales Summary" },
  { key: "itemSummary", label: "Item Summary" },
  { key: "itemisedSales", label: "Itemised Sales" },
  { key: "categorySales", label: "Category Sales" },
  { key: "estimates", label: "Estimates" },
];

const ShiftNavbar = ({ selected, onSelect, onCloseShift, onShiftChange, selectedShiftId }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => setDialogOpen(true);
  const closeDialog = () => setDialogOpen(false);

  const handleSubmit = (checks) => {
    setDialogOpen(false);
    if (onCloseShift) onCloseShift(checks);
  };

  const allShifts = JSON.parse(localStorage.getItem(STORAGE_KEYS.ALL_SHIFTS) || "[]");

  // const handleSyncSale = () => {
  //   toast.success("Coming soon");
  // };

  // const handleForceSync = () => {
  //   toast.success("Coming soon");
  // };

  return (
    <div className={styles.sidebar}>
      <div>
        <h3>Shift Management</h3>
        <div className={styles.shiftName}>
          <h5>Switch Shift</h5>

          <FormControl fullWidth variant="standard" sx={{ m: 0 }}>
            <Select
              value={selectedShiftId ? String(selectedShiftId) : ""}
              onChange={(e) => {
                const newId = e.target.value;
                if (onShiftChange) onShiftChange(newId);
              }}
              disableUnderline
              displayEmpty
              IconComponent={KeyboardArrowDownIcon}
              sx={{
                fontSize: "14px",
                fontWeight: 600,
                color: "#2b2b2b",
                maxWidth: "140px",

                "& .MuiSelect-select": {
                  padding: "0 !important",
                  paddingRight: "24px !important",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                },

                "& .MuiSvgIcon-root": {
                  position: "absolute",
                  right: "0px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                },
              }}
            >
              {allShifts.map((shift) => (
                <MenuItem key={shift.id} value={shift.id}>
                  {shift.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <button className={styles.closeShift} onClick={openDialog}>
          Close Shift
        </button>
      </div>

      <div>
        <h3>Print Report</h3>
        <ul className={styles.menu}>
          {menuItems.map((item) => (
            <li
              key={item.key}
              className={`${styles.menuItem} ${selected === item.key ? styles.active : ""}`}
              onClick={() => onSelect(item.key)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>

      {/* <div className={styles.syncSection}>
        <h3>Cloud Sync</h3>
        <div>
          <button className={`${styles.menuItem} ${styles.active}`} onClick={handleForceSync}>
            Force Sync
          </button>
          <button className={`${styles.menuItem} ${styles.active}`} onClick={handleSyncSale}>
            Sync Sales
          </button>
        </div>
      </div> */}

      {dialogOpen && <CloseShiftDialog open={dialogOpen} onClose={closeDialog} onSubmit={handleSubmit} />}
    </div>
  );
};

export default ShiftNavbar;
